module.exports = __webpack_public_path__ + "img/6.03ce5e42.svg";